export const Links = [
  {
    href: "/rent-private-number",
    name: "🔥 Rent Private Number",
  },
  {
    href: "/free-temporary-numbers",
    name: "☎️  Free Temp Numbers",
  },
  {
    href: "/sms-verification",
    name: "✅ SMS Verification",
  },
  {
    href: "/global-esim-data-roaming",
    name: "🌍 Global eSIM Data",
  },
  {
    href: "/guides",
    name: "💥 Guides",
  },
];
